// Base stylesheet needed for every page
import './scss/app.scss';
import initVariantAvailabilityFix from './scripts/variant-availability-fix';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantAvailabilityFix);
} else {
  initVariantAvailabilityFix();
}

